import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getManualImageAsset, imageBaseNames } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterSubHeadline } from '../chapterComponents/ChapterSubHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { TranslationsKeys, useCustomIntl } from '../../../../i18n/i18n';
import useDarkMode from '@rio-cloud/rio-uikit/useDarkMode';

type GuideStep = {
  headline: TranslationsKeys;
  text: TranslationsKeys;
  image: string;
};

export const GetStartedGuideChapter: React.FC = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();
  const isDarkMode = useDarkMode();

  const steps: GuideStep[] = [
    {
      headline: 'userManual.getStarted.guide.step1.headline',
      text: 'userManual.getStarted.guide.step1.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_getStarted_step1,
        locale,
        isDarkMode,
      ),
    },
    {
      headline: 'userManual.getStarted.guide.step2.headline',
      text: 'userManual.getStarted.guide.step2.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_getStarted_step2,
        locale,
        isDarkMode,
      ),
    },
    {
      headline: 'userManual.getStarted.guide.step3.headline',
      text: 'userManual.getStarted.guide.step3.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_getStarted_step3,
        locale,
        isDarkMode,
      ),
    },
    {
      headline: 'userManual.getStarted.guide.step4.headline',
      text: 'userManual.getStarted.guide.step4.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_getStarted_step4,
        locale,
        isDarkMode,
      ),
    },
    {
      headline: 'userManual.getStarted.guide.step5.headline',
      text: 'userManual.getStarted.guide.step5.text',
      image: getManualImageAsset(
        imageBaseNames.getStarted_getStarted_step5,
        locale,
        isDarkMode,
      ),
    },
  ];

  return (
    <div>
      <ChapterHeadline messageId={'userManual.getStarted.guide.headline'} />
      <div className={'row'}>
        <div className={'col-xs-12 col-md-6 padding-0'}>
          <ChapterText messageId={'userManual.getStarted.guide.intro'} />
        </div>
      </div>
      <div className={'row margin-top-20'}>
        {steps.map((step) => (
          <div
            key={step.headline}
            className={
              'col-xs-12 display-flex gap-25 margin-y-25 padding-0 flex-column flex-row-md'
            }
          >
            <div className={'col-xs-12 col-md-6 padding-0'}>
              <ChapterSubHeadline
                messageId={step.headline}
                textSize={'h5'}
              />
              <ChapterText
                marginBottom={0}
                messageId={step.text}
              />
            </div>
            <div className={'col-xs-12 col-md-6'}>
              <ImageLoader
                src={step.image}
                alt={formatMessage({ id: step.headline })}
                className={'border'}
                enlargeable
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
